import { render } from "./CompassHud.vue?vue&type=template&id=644aa133"
import script from "./CompassHud.vue?vue&type=script&lang=js"
export * from "./CompassHud.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__